import React, { useEffect, useState } from 'react';

import StickiesList from '../../components/StickiesList/StickiesList';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import ErrorModal from '../../components/Modal/ErrorModal';
import Button from '../../components/Button/Button';

import { useHttpClient } from '../../hooks/http-hook';

import Modal from '../../components/Modal/Modal';
import DetailModal from '../../components/Modal/DetailModal';

import NoStickies from '../../components/NoStickies/NoStickies';
import NoStickiesFound from '../../components/NoStickiesFound/NoStickiesFound';
import SortModal from '../../components/Modal/SortModal';
import FilterModal from '../../components/Modal/FilterModal';
import Backdrop from '../../components/Backdrop/Backdrop';
import SortFilterView from '../../components/SortFilterView/SortFilterView';

import Numbers from '../../components/Visualizations/Numbers/Numbers';
import Categories from '../../components/Visualizations/Categories/Categories';
import WordCloud from '../../components/Visualizations/WordCloud/WordCloud';
import MostRecent from '../../components/Visualizations/MostRecent/MostRecent';
import MostLiked from '../../components/Visualizations/MostLiked/MostLiked';
import MediaType from '../../components/Visualizations/MediaType/MediaType';
import Frequency from '../../components/Visualizations/Frequency/Frequency';

// import Pie from '../../components/Visualizations/Charts/Pie/Pie';

import styles from './Stats.module.css';

let fetchedStickies = [];

const Stats = (props) => {
  const { isLoading, error, sendRequest, clearError } = useHttpClient();
  // const [ isDetail, setIsDetail ] = useState(true);
  const [detailContent, setDetailContent] = useState([]);
  const [loadedStickies, setLoadedStickies] = useState();
  const [latestSticky, setLatestSticky] = useState();
  // const [viewIndex, setViewIndex] = useState(0);
  const [scrollUp, setScrollUp] = useState(true);
  const [stickyNotesNum, setStickyNotesNum] = useState(0);
  const [categoriesArray, setCategoriesArray] = useState([]);
  const [mlCatArray, setMlCatArray] = useState([]);
  const [mlMediaArray, setMlMediaArray] = useState([]);
  const [frequencyArray, setFrequencyArray] = useState(null);
  const [mostLikedArray, setMostLikedArray] = useState();
  const [mediaTypeArray, setMediaTypeArray] = useState([]);

  // useEffect(() => {
  //   setLoadedStickies(DUMMY_DATA);
  // }, []);

  useEffect(() => {
    const fetchStickies = async () => {
      try {
        const responseData = await sendRequest(
          'https://no2.dev/stickynotes/api/'
        );

        // console.log('fetched!');
        // console.log(responseData);

        const fetchedData = responseData.stickies;
        // const fetchedData = responseData.stickies.reverse();
        fetchedStickies = [...fetchedData];
        setLoadedStickies(fetchedData);
        calcFrequency(fetchedData);
        setLatestSticky(fetchedData[fetchedData.length - 1]);
        setMostLikedArray(fetchedData[3]);
        calcStickyNotes(fetchedData);
        calcMostLiked(fetchedData);
        calcMediaType(fetchedData);
      } catch (err) {
        // console.log('error during fetching!');
        // console.log(err);
      }
    };
    fetchStickies();
  }, [sendRequest]);

  // useEffect(() => {
  //   calcFrequency();
  // }, [frequencyArray]);

  const calcStickyNotes = (ls) => {
    let amount = 4;
    if (!ls) {
      amount = 0;
    } else {
      amount = ls.length;
    }
    // console.log(amount);
    setStickyNotesNum(amount);

    let catArray = [];
    ls.forEach((item) => {
      // console.log(item);
      item.tags.forEach((i) => {
        const catThere = (catArray) => catArray.category === i;
        const testCat = catArray.some(catThere);
        if (!testCat) {
          // console.log('not there!');
          catArray.push({ category: i, count: 1 });
        } else {
          // console.log('already there!');
          const catId = catArray.map((e) => e.category).indexOf(i);
          // console.log(catId);
          const getEntry = catArray[catId];
          const newEntry = { ...catArray[catId], count: getEntry.count + 1 };
          catArray.splice(catId, 1, newEntry);
        }
      });
    });
    // catArray.sort((a, b) => parseFloat(a.count) - parseFloat(b.count));
    catArray.sort((a, b) => parseFloat(b.count) - parseFloat(a.count));
    // console.log(catArray);
    setCategoriesArray(catArray);
  };

  const calcFrequency = (ls) => {

    // if (!frequencyArray) {
    //   console.log('FA: ', frequencyArray);
    //   console.log('nope!');
    //   return;
    // } else {
    //   console.log('FA: ', frequencyArray);
    //   console.log('yes');

    let monthlyFrequencyArray = [];
    let dailyFrequencyArray = [];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const posts = [];
    
    const firstMap = ls.forEach(i => {
      const newObj = { month: months[new Date(i.date).getMonth()], day: new Date(i.date).getDate(), count: 1 };
      monthlyFrequencyArray.push(newObj);
    });
    // setFrequencyArray(monthlyFrequencyArray);
        // console.log('MFA: ', monthlyFrequencyArray);

    // const monthArray = [];
    // monthlyFrequencyArray.forEach(item => {
    //   item.month.forEach((i) => {
    //         const monthThere = (monthArray) => monthArray.month === i;
    //         const testMonth = monthArray.some(monthThere);
    //         if (!testMonth) {
    //           // console.log('not there!');
    //           monthArray.push({ month: i, count: 1 });
    //         } else {
    //           // console.log('already there!');
    //           const catId = monthArray.map((e) => e.month).indexOf(i);
    //           // console.log(catId);
    //           const getEntry = monthArray[catId];
    //           const newEntry = { ...monthArray[catId], count: getEntry.count + 1 };
    //           monthArray.splice(catId, 1, newEntry);
    //         }
    //       });
    // });

    // console.log('monthArray: ', monthArray);
  // }
    // console.log('MFA: ', monthlyFrequencyArray);

    // console.log('SETTING FREQUENCY ARRAY!');
    // setFrequencyArray([{month: 'Nov21', count: 24}, {month: 'Dec21', count: 12}, {month: 'Jan22', count: 24}]);
    // console.log('FRERQUENCY ARRAY WAS SET!');
  };

  const calcMostLiked = (ls) => {
    // setMostLikedArray(
    //   {"tags":["barn"],"media":["pencil"],"_id":"619fd370d99e65db03dfc7f7","date":"Thu Nov 25 2021 10:18:21 GMT-0800 (PST)","image":"barn_141983b0-4e1c-11ec-9afc-cb5dee15013a.jpeg","likes":12,"__v":1,"id":"619fd370d99e65db03dfc7f7"}
    // );
    const sorted = ls.sort(function (a, b) {
        return b.likes - a.likes;
      });
      // console.log('sorted: ', sorted[0]);
    setMostLikedArray(sorted[0]);

    let catArray = [];
    ls.forEach((item) => {
      // console.log(item);
      item.tags.forEach((i) => {
        const catThere = (catArray) => catArray.category === i;
        const testCat = catArray.some(catThere);
        if (!testCat) {
          // console.log('not there!');
          catArray.push({ category: i, likes: item.likes });
        } else {
          // console.log('already there!');
          const catId = catArray.map((e) => e.category).indexOf(i);
          // console.log(catId);
          const getEntry = catArray[catId];
          const newEntry = { ...catArray[catId], likes: getEntry.likes + item.likes };
          catArray.splice(catId, 1, newEntry);
        }
      });
    });
    // catArray.sort((a, b) => parseFloat(a.count) - parseFloat(b.count));
    catArray.sort((a, b) => parseFloat(b.count) - parseFloat(a.count));
    // console.log('CAT BY LIKES: ', catArray);
    setMlCatArray(catArray);

    let medArray = [];
    ls.forEach((item) => {
      // console.log(item);
      item.media.forEach((i) => {
        const catThere = (medArray) => medArray.media === i;
        const testCat = medArray.some(catThere);
        if (!testCat) {
          // console.log('not there!');
          medArray.push({ media: i, likes: item.likes });
        } else {
          // console.log('already there!');
          const catId = medArray.map((e) => e.media).indexOf(i);
          // console.log(catId);
          const getEntry = medArray[catId];
          const newEntry = { ...medArray[catId], likes: getEntry.likes + item.likes };
          medArray.splice(catId, 1, newEntry);
        }
      });
    });
    // catArray.sort((a, b) => parseFloat(a.count) - parseFloat(b.count));
    medArray.sort((a, b) => parseFloat(b.likes) - parseFloat(a.likes));
    console.log('MED BY LIKES: ', medArray);
    setMlMediaArray(medArray);

    // setMostLikedArray(sortedData[0]);
    // catArray.sort((a, b) => parseFloat(a.count) - parseFloat(b.count));
    // catArray.sort((a, b) => parseFloat(b.count) - parseFloat(a.count));
    // console.log(catArray);
    // setMostLikedArray(trimmedData);
  };

  const calcMediaType = (ls) => {
    let catArray = [];
    ls.forEach((item) => {
      // console.log(item);
      item.media.forEach((i) => {
        const catThere = (catArray) => catArray.media === i;
        const testCat = catArray.some(catThere);
        if (!testCat) {
          // console.log('not there!');
          catArray.push({ media: i, count: 1 });
        } else {
          // console.log('already there!');
          const catId = catArray.map((e) => e.media).indexOf(i);
          // console.log(catId);
          const getEntry = catArray[catId];
          const newEntry = { ...catArray[catId], count: getEntry.count + 1 };
          catArray.splice(catId, 1, newEntry);
        }
      });
    });
    // catArray.sort((a, b) => parseFloat(a.count) - parseFloat(b.count));
    catArray.sort((a, b) => parseFloat(b.count) - parseFloat(a.count));
    // console.log('Media Type: ', catArray);
    setMediaTypeArray(catArray);
  };

  const calcDays = (ls) => {};

  const sortData = (type) => {
    sortReset();
    if (type === 'NEWEST') {
      const sortedData = loadedStickies.sort(
        (a, b) => Date.parse(b.date) - Date.parse(a.date)
      );
      setLoadedStickies(sortedData);
    } else if (type === 'OLDEST') {
      const sortedData = loadedStickies.sort(
        (b, a) => Date.parse(b.date) - Date.parse(a.date)
      );
      setLoadedStickies(sortedData);
    } else if (type === 'MOST_FAVORITE') {
    } else if (type === 'LEAST_FAVORITE') {
    }
  };

  const sortReset = () => {
    setLoadedStickies((prev) => fetchedStickies);
  };

  const filterData = (type) => {
    const filteredData = [...fetchedStickies];
    // const filteredFilteredData = filteredData.some(str => str.includes(type));
    // const filteredFilteredData = filteredData.filter(item => item.tags[0] === type);
    const filteredFilteredData = filteredData.filter(
      (item) => item.tags.indexOf(type) >= 0
    );
    setLoadedStickies(filteredFilteredData);
  };

  const detailHandler = (id) => {
    const content = loadedStickies.find((s) => s.id === id);
    console.log(content.id);
    const show = true;
    const contId = content.id;
    const contImage = content.image;
    const contDate = content.date;
    const contTags = content.tags.join(', ');
    const contLikes = content.likes;
    setDetailContent([contId, contImage, contDate, contTags, contLikes]);
    console.log(detailContent);
  };

  // ###########

  const [scrollDir, setScrollDir] = useState('scrolling down');

  useEffect(() => {
    const threshold = 0;
    let lastScrollY = window.pageYOffset;
    let ticking = false;

    const updateScrollDir = () => {
      const scrollY = window.pageYOffset;

      if (Math.abs(scrollY - lastScrollY) < threshold) {
        ticking = false;
        return;
      }
      setScrollDir(
        scrollY > lastScrollY ? setScrollUp(false) : setScrollUp(true)
      );
      lastScrollY = scrollY > 0 ? scrollY : 0;
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollDir);
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll);
    // console.log(scrollDir);

    return () => window.removeEventListener('scroll', onScroll);
  }, [scrollDir]);

  // ###########

  return (
    <div className={styles.statsContainer}>
      <div className={styles.headerDiv}>
        <h1>Sticky Note Stats!</h1>
      </div>
      <div className={styles.rowOne}>
        <div className={styles.numbersDiv}>
          <Numbers
            stickyNotesNum={stickyNotesNum}
            categoriesArray={categoriesArray}
          />
          <MostRecent
            latestSticky={latestSticky}
            loadedStickies={loadedStickies}
          />
        </div>
        <div className={styles.categoriesDiv}>
          <Categories categoriesArray={categoriesArray} />
        </div>
      </div>
      <div className={styles.rowTwo}>
        <div className={styles.frequencyDiv}>
          <Frequency
            loadedStickies={loadedStickies}
          />
        </div>
        <div className={styles.mostLikedDiv}>
          <MostLiked mostLikedArray={mostLikedArray} catArray={mlCatArray} mediaArray={mlMediaArray}/>
        </div>
        <div className={styles.rowThree}>
        <div className={styles.mediaTypeDiv}>
          <MediaType mediaTypeArray={mediaTypeArray} />
        </div>
        </div>
      </div>
      {/* <div className={styles.wordCloudDiv}>
      <WordCloud
        categoriesArray={categoriesArray}
      />
      </div> */}
      {/* <div className={styles.charts}>
      <Pie categoriesArray={categoriesArray}/>
      </div> */}
    </div>
  );
};

export default Stats;
